<template>
  <div class="productDetailPage">
    <!-- 显示一级和二级标题 -->
    <div class="title-container flex-rowl">
      <h1>{{ firstLevelTitle }}</h1> <i class="iconfont icon-xiangshangjiantou"></i> 
      <h2>{{ secondLevelTitle }}</h2>
    </div>
    <div class="product-detail-main">
      <router-view />
    </div>
    <div class="join_wrap">
      <!-- <div class="img">
        <img :src="require('@/assets/images/join_bg.png')" alt="" />
      </div> -->
      <div class="content flex-colc wow animate__animated animate__slideInUp">
        <div class="title">
          <p class="txt1 f-times-new-roman">Join</p>
          <p class="txt2">VESCOR致力於為內外兼修的現代女性打造</p>
          <p class="txt3">奢寵保養體驗計劃</p>
        </div>
        <div class="txt">
          <p>
            我們一起，追求自然與科學的平衡，關注肌膚內外健康，同時無懼時間流轉，堅定探索自我。
          </p>
          <p>
            無論是在職場中自信應對挑戰，或是在生活中優雅淡然，VESCOR始終與她們相伴，賦予她們從容與美麗。
          </p>
        </div>
        <div class="more flex-rowc" @click="handleGo('ProductPage')">了解詳情...</div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "ProductDetailPage",
  data() {
    return {
      firstLevelTitle: "",
      secondLevelTitle: "",
    };
  },
  mounted() {
    this.setTitles();
    this.$router.afterEach(() => {
      this.setTitles();
    });
  },
  methods: {
    handleGo(link) {
      this.$router.push(link);
    },
    
    setTitles() {
      const currentRoute = this.$route.matched.find(route => route.name === this.$route.name);
      this.firstLevelTitle = currentRoute ? currentRoute.meta.firstLevelTitle : '';
      this.secondLevelTitle = currentRoute ? currentRoute.meta.secondLevelTitle : '';
    },
  },
};
</script>
  <style lang="less">
.productDetailPage {
  padding-top: 96px;
  box-sizing: border-box;
  .title-container {
    width: 1340px;
    margin: auto;
    padding: 21px 0 30px;
    font-size: 20px;
    color: #999999;
    .icon-xiangshangjiantou {
      margin: 0 10px;
      transform: rotate(90deg);
      font-size: 14px;
    }
    h2 {
      color: #333333;
    }
  }
  .product-detail-main {
    width: 1340px;
    margin: auto;
  }
  .join_wrap {
    position: relative;
    margin-bottom: 127px;
    background: url("https://upload.vwingist.com/melscn/0image/2025/04/5175367247852106837.png")
      no-repeat center;
    background-size: cover;
    width: 100%;
    height: 750px;
    padding: 120px 0 0 279px;
    box-sizing: border-box;
    margin-top: 140px;
    .content {
      width: 695px;
      align-items: flex-start;
      .title {
        color: #000000;
        font-family: "SourceHanSerifCN-Medium", sans-serif;
        .txt1 {
          font-size: 60px;
        }
        .txt2 {
          font-size: 36px;
          margin: 5px 0;
        }
        .txt3 {
          font-size: 50px;
        }
      }
      .txt {
        margin: 50px 0 40px;
        font-size: 20px;
        p {
          line-height: 27px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
      .more {
        font-family: "SourceHanSansCN-Light", sans-serif;
        width: 165px;
        height: 50px;
        background: #e9e9e9;
        font-size: 20px;
        cursor: pointer;
        &:hover {
          background: #333333;
          color: #fff;
        }
      }
    }
  }
}
</style>